<template lang="pug">
footer.hn-footer
  footer-list
  .container
    .row.row-centered
      .col-md-10.mt-3
        .text-muted © {{ year }} Halal Navi by Asiana Tech Sdn. Bhd. (113665-V)
      .col-md-2.mt-3
        select.form-control(v-model="lang")
          option(value="en") English
          option(value="ja") 日本語
</template>

<script>
import { mapActions } from 'vuex'
import FooterList from './FooterList'

export default {
  components: {
    FooterList
  },
  data () {
    return {
      year: (new Date()).getFullYear(),
      lang: this.$store.state.language.lang
    }
  },
  watch: {
    lang (val, oldVal) {
      this.$i18n.locale = val
      this.setLanguage(val)
    }
  },
  methods: {
    ...mapActions(['setLanguage'])
  }
}
</script>

<style lang="scss">

.hn-footer {
  padding-bottom: 1rem;
  background: #111;
  color: #fff;
  font-size: 0.875rem;
  position: absolute;
  bottom: 0;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue